/*
*
* File JS Principale
*
*/
// IMPORT JQUERY
//--------------------------------------------------------------------//

import $ from 'jquery';


// IMPORT SCSS PER LA COMPILAZIONE
//--------------------------------------------------------------------//

import 'scss/app.scss';

//--------------------------------------------------------------------//

// Carichiamo i font in maniera asincrona
//--------------------------------------------------------------------//

var Webfont = require('webfontloader');

Webfont.load({
    google: {
        families: ['Fraunces:300,400', 'Nunito:400,600&display=swap']
    }
});

//--------------------------------------------------------------------//

// Libreria Lazysizes
//--------------------------------------------------------------------//
import 'lazysizes';

//--------------------------------------------------------------------//

// Import Utilies
//--------------------------------------------------------------------//

import { initSvgImage } from './utilities/img-svg';
import smoothScroll from './utilities/smooth-scroll';
import initAnimations from './utilities/animations';

//--------------------------------------------------------------------//


// Init Utilies
//--------------------------------------------------------------------//

initSvgImage();

smoothScroll();

initAnimations();

//--------------------------------------------------------------------//


// Import Componenti
//--------------------------------------------------------------------//

import languageList from 'components/language-list/language-list';

import messages from 'components/messages/messages';

import initHeader from 'components/header/header';

import footer from 'components/footer/footer';

import bannerNewsletter from 'components/banner-newsletter/banner-newsletter';

import accordion from 'imComponents/accordion/accordion';

import booking from 'components/booking/booking';

//--------------------------------------------------------------------//


// Init Componenti
//--------------------------------------------------------------------//

initHeader();

accordion();

messages();

booking();

//--------------------------------------------------------------------//


// Funzione per modificare la posizione delle label nei form
//--------------------------------------------------------------------//
const modifyPositionLabels = () => {
    let allFormGroups = document.querySelectorAll('.form .form-group.float-label');

    if(!allFormGroups.length) return;

    allFormGroups.forEach(el => {
        let thisFormControl = el.querySelector('.wpcf7-form-control-wrap');
        let thisLabel = el.querySelector('label');

        el.removeChild(thisLabel);
        thisFormControl.appendChild(thisLabel);
    });
}
modifyPositionLabels();